import React from 'react'
import { Menu as AntMenu } from 'antd'
import { MenuProps as AntMenuProps } from 'antd/lib/menu'
import { SubMenuProps as AntSubMenuProps } from 'antd/lib/menu/SubMenu'
import { MenuItemProps as AntMenuItemProps } from 'antd/lib/menu/MenuItem'
import { MenuItemGroupProps } from 'antd/node_modules/rc-menu/lib/MenuItemGroup'
import { DividerProps } from 'antd/node_modules/rc-menu/lib/Divider'

import styles from './_.module.css'

const { SubMenu: AntSubMenu, Item: AntItem, ItemGroup: AntItemGroup } = AntMenu

type MenuProps = AntMenuProps
type SubMenuProps = AntSubMenuProps
type MenuItem = AntMenuItemProps

/* 
 NOTE: internally antd passes some props from Menu to SubMenu, MenuItem & ItemGroup
    removing {...props} when wrapper will result in error
*/
export const Menu: React.FC<MenuProps> = ({
  children,
  defaultSelectedKeys,
  selectedKeys,
  inlineCollapsed,
  mode,
  ...props
}) => {
  const controlledProps = {
    ...(inlineCollapsed !== undefined && { inlineCollapsed })
  }

  return (
    <AntMenu
      className={styles.menu}
      mode={mode}
      defaultSelectedKeys={defaultSelectedKeys}
      selectedKeys={selectedKeys}
      {...controlledProps}
      {...props}
    >
      {children}
    </AntMenu>
  )
}

export const SubMenu: React.FC<SubMenuProps> = ({
  children,
  title,
  icon,
  disabled,
  ...props
}) => (
  <AntSubMenu title={title} icon={icon} disabled={disabled} {...props}>
    {children}
  </AntSubMenu>
)

export const MenuItem: React.FC<MenuItem> = ({ children, icon, ...props }) => (
  <AntItem icon={icon} {...props}>
    {children}
  </AntItem>
)

export const ItemGroup: React.FC<MenuItem> = ({
  title,
  children,
  ...props
}) => (
  <AntItemGroup title={title} {...props}>
    {children}
  </AntItemGroup>
)

export const MenuDivider = (props: DividerProps): JSX.Element => (
  <AntMenu.Divider {...props} />
)

export const MenuItemGroup: React.FC<MenuItemGroupProps> = ({
  children,
  ...props
}) => <AntMenu.ItemGroup {...props}>{children}</AntMenu.ItemGroup>
